import { Injectable } from '@angular/core';
import { ApiService } from '@nrwl/common-lib';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TemplateService {
  templateID: string = null;
  closeDialog: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private createTestTemplate = '/uicomm/createTestTemplate';
  private updateTestTemplate = '/uicomm/updateTestTemplate';
  private getTestTemplate = '/uicomm/getTestTemplate';
  private findTestTemplates = '/uicomm/findTestTemplates';
  private shareTestTemplate = '/uicomm/shareTestTemplate';
  private unshareTestTemplate = '/uicomm/unshareTestTemplate';
  private setDefaultTestTemplate = '/uicomm/setDefaultTestTemplate';
  private unsetDefaultTestTemplate = '/uicomm/unsetDefaultTestTemplate';
  private removeTestTemplate = '/uicomm/removeTestTemplates';

  constructor(private readonly apiService: ApiService) {}
  /* eslint-disable-next-line */
  _saveTemplate(templateConfig: any): any {
    /* eslint-disable-next-line */
    return this.apiService.post$<any>(this.createTestTemplate, templateConfig);
  }
  /* eslint-disable-next-line */
  _updateTemplate(templateConfig: any): any {
    /* eslint-disable-next-line */
    return this.apiService.post$<any>(this.updateTestTemplate, templateConfig);
  }
  /* eslint-disable-next-line */
  _getTestTemplate(templateId: any): any {
    /* eslint-disable-next-line */
    return this.apiService.post$<any>(this.getTestTemplate + '/' + templateId + '?listOnly=true');
  }
  /* eslint-disable-next-line */
  setTemplateId(id: string): any {
    this.templateID = id;
  }
  getTemplateId(): string {
    return this.templateID;
  }
  /* eslint-disable-next-line */
  _findTestTemplates(payload: any): any {
    /* eslint-disable-next-line */
    return this.apiService.post$<any>(this.findTestTemplates, payload);
  }
  /* eslint-disable-next-line */
  _shareTemplate(templateId: any): any {
    /* eslint-disable-next-line */
    return this.apiService.post$<any>(this.shareTestTemplate + '/' + templateId);
  }
  /* eslint-disable-next-line */
  _unshareTemplate(templateId: any): any {
    /* eslint-disable-next-line */
    return this.apiService.post$<any>(this.unshareTestTemplate + '/' + templateId);
  }
  /* eslint-disable-next-line */
  _setDefaultTemplate(templateId: any): any {
    /* eslint-disable-next-line */
    return this.apiService.post$<any>(this.setDefaultTestTemplate + '/' + templateId);
  }
  /* eslint-disable-next-line */
  _unsetDefaultTemplate(templateId: any): any {
    /* eslint-disable-next-line */
    return this.apiService.post$<any>(this.unsetDefaultTestTemplate + '/' + templateId);
  }
  /* eslint-disable-next-line */
  _removeTemplate(templateId: any): any {
    /* eslint-disable-next-line */
    return this.apiService.post$<any>(this.removeTestTemplate, templateId);
  }

  closeTemplateDialog(): void {
    this.closeDialog.next(true);
  }
}
